/** @format */

import * as yup from 'yup';

import {MAX_COMMENT, MAX_INN, MAX_LINK, MAX_NAME, MAX_PHONE, MIN_INN} from './constants';
import {FormState} from './types';

export const validationSchema: yup.ObjectSchema<FormState> = yup.object().shape({
  name: yup.string().trim().max(MAX_NAME).required(),
  phone: yup.string().trim().max(MAX_PHONE).required(),
  link: yup.string().trim().max(MAX_LINK).required(),
  inn: yup
    .string()
    .trim()
    .min(MIN_INN)
    .max(MAX_INN)
    .matches(/^[0-9]+$/)
    .required(),
  comment: yup.string().trim().max(MAX_COMMENT).defined(),
});
